import { IAuthToken } from '../models/auth';
import { RecordingBatch } from '../models/recording_batch';
import { IApiService, IPaginatedResponse } from '../services/api_service';
import config from '../services/config';

export const recordingBatch = (siteApi: IApiService, getToken: () => IAuthToken) => ({
  index: (params = {}): Promise<IPaginatedResponse<RecordingBatch>> => {
    return siteApi.get('/recording-batch', { params });
  },
  get: (id) => {
    return siteApi.get(`/recording-batch/${id}`);
  },
  getDownloadUrl: (id) => {
    return `${config.api.url}/recording-batch/${id}/download?token=${getToken().accessToken}`;
  }
});
